"use client";

import { FC, PropsWithChildren, useEffect, useRef } from "react";

export const TopBannersContainer: FC<PropsWithChildren> = ({ children }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function updateBannerHeight(): void {
      if (!containerRef.current) return;

      const height = Math.round(
        containerRef.current.getBoundingClientRect().height
      );

      document.documentElement.style.setProperty(
        "--top-banners-height",
        `${height}px`
      );
    }

    if (!containerRef.current) return;

    updateBannerHeight();

    const resizeObserver = new ResizeObserver((entries) => {
      if (entries.length > 0 && entries[0].target === containerRef.current) {
        updateBannerHeight();
      }
    });

    resizeObserver.observe(containerRef.current);

    return () => {
      resizeObserver.disconnect();
      document.documentElement.style.removeProperty("--top-banners-height");
    };
  }, []);

  return <div ref={containerRef}>{children}</div>;
};
